var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.isSecondary
      ? _c("div", { staticClass: "courseL" }, [
          _vm.prizeList.length > 0
            ? _c(
                "div",
                { staticClass: "list" },
                _vm._l(_vm.prizeList, function (item) {
                  return _c("div", { key: item.id, staticClass: "listItem" }, [
                    _c(
                      "div",
                      {
                        staticClass: "winItem",
                        on: {
                          click: function ($event) {
                            return _vm.openLink(
                              item.courseLink || item.freeLink
                            )
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "itembox" }, [
                          _c("div", { staticClass: "title" }, [
                            _c("div", [_vm._v(_vm._s(item.courseName))]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "line" }),
                          _vm._v(" "),
                          _c("div", { staticClass: "school" }, [
                            _vm._v(_vm._s(item.fkCourseEmceeSchool || "---")),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "tips" }, [
                            item.courseLevel
                              ? _c("div", { staticClass: "name" }, [
                                  _vm._v(_vm._s(item.courseLevel)),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            item.majorName || item.fkCourseMajor
                              ? _c("div", { staticClass: "name" }, [
                                  _vm._v(
                                    _vm._s(item.majorName || item.fkCourseMajor)
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                        ]),
                      ]
                    ),
                  ])
                }),
                0
              )
            : _c(
                "div",
                {
                  staticStyle: { "margin-top": "50px", "text-align": "center" },
                },
                [_c("img", { attrs: { src: _vm.$store.getters.noData } })]
              ),
        ])
      : _c("div", { staticClass: "courseH" }, [
          _vm._m(0),
          _vm._v(" "),
          _vm.onlineList.length > 0
            ? _c(
                "div",
                { staticClass: "list" },
                _vm._l(_vm.onlineList, function (item) {
                  return _c("div", { key: item.id, staticClass: "listItem2" }, [
                    _c(
                      "div",
                      {
                        staticClass: "item item2",
                        on: {
                          click: function ($event) {
                            return _vm.openLink(
                              item.courseLink || item.freeLink
                            )
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "img2" }, [
                          _c("img", {
                            attrs: {
                              src: item.courseImage || _vm.$store.getters.noImg,
                            },
                          }),
                          _vm._v(" "),
                          item.courseLevel
                            ? _c(
                                "div",
                                {
                                  staticClass: "leb1",
                                  class: _vm.levelClass(item.courseLevel),
                                },
                                [_vm._v(_vm._s(item.courseLevel))]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          item.fkCourseEmceeSchool
                            ? _c("div", { staticClass: "prov" }, [
                                _vm._v(_vm._s(item.fkCourseEmceeSchool)),
                              ])
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "mainText" }, [
                          _c("div", { staticClass: "tit" }, [
                            _vm._v(_vm._s(item.courseName)),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "sourse" }, [
                            _c(
                              "div",
                              {
                                staticClass: "text_w",
                                staticStyle: { "margin-bottom": "5px" },
                              },
                              [
                                _vm._v(
                                  "学校：" +
                                    _vm._s(item.fkCourseEmceeSchool || "---")
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "text2" }, [
                            _c("div", { staticClass: "name" }, [
                              _vm._v(
                                _vm._s(
                                  item.courseTeacher ||
                                    item.courseEmceeName ||
                                    "---"
                                )
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "line2" }),
                          _vm._v(" "),
                          _c("div", { staticClass: "text2" }, [
                            _c("div", { staticClass: "name" }, [
                              _vm._v(
                                "来源：" + _vm._s(item.courseFrom || "---")
                              ),
                            ]),
                          ]),
                        ]),
                      ]
                    ),
                  ])
                }),
                0
              )
            : _c(
                "div",
                {
                  staticStyle: { "margin-top": "50px", "text-align": "center" },
                },
                [_c("img", { attrs: { src: _vm.$store.getters.noData } })]
              ),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          _vm.prizeList.length > 0
            ? _c(
                "div",
                { staticClass: "list" },
                _vm._l(_vm.prizeList, function (item) {
                  return _c(
                    "div",
                    { key: "prize-" + item.id, staticClass: "listItem" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "winItem",
                          on: {
                            click: function ($event) {
                              return _vm.openLink(
                                item.courseLink || item.freeLink
                              )
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "itembox" }, [
                            _c("div", { staticClass: "title" }, [
                              _c("div", [_vm._v(_vm._s(item.courseName))]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "line" }),
                            _vm._v(" "),
                            _c("div", { staticClass: "school" }, [
                              _vm._v(_vm._s(item.fkCourseEmceeSchool || "---")),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "tips" }, [
                              item.courseLevel
                                ? _c("div", { staticClass: "name" }, [
                                    _vm._v(_vm._s(item.courseLevel)),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              item.majorName || item.fkCourseMajor
                                ? _c("div", { staticClass: "name" }, [
                                    _vm._v(
                                      _vm._s(
                                        item.majorName || item.fkCourseMajor
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                          ]),
                        ]
                      ),
                    ]
                  )
                }),
                0
              )
            : _c(
                "div",
                {
                  staticStyle: { "margin-top": "50px", "text-align": "center" },
                },
                [_c("img", { attrs: { src: _vm.$store.getters.noData } })]
              ),
        ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "subitem" }, [
      _c("img", {
        attrs: { src: require("../assets/img/image/icon-online.svg") },
      }),
      _vm._v(" 在线精品课"),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "subitem" }, [
      _c("img", {
        attrs: { src: require("../assets/img/image/icon-prize.svg") },
      }),
      _vm._v(" 教学能力比赛获奖作品"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }